import { FreightPickupAccessorialPresetRowSchema } from "@redotech/redo-fulfillment-common/freight/freight-pickup-accessorial-preset";
import * as z from "zod";

export const createFreightPickupAccessorialPreset = {
  name: "createFreightPickupAccessorialPreset" as const,
  input: z.object({
    name: z.string(),
    liftgateRequired: z.boolean(),
    insidePickup: z.boolean(),
    instructions: z.string().nullish(),
  }),
  output: FreightPickupAccessorialPresetRowSchema,
};
